import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'pages',
  children: {
    all: {
      path: 'all',
    },
    detail: {
      path: ':id',
    },
  },
} as const satisfies Location
